/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/
import { NgModule } from '@angular/core';
import { OnlyNumberDirective } from './only-number.directive';
import { TwoDigitDecimaNumberDirective } from './two-digit-decimal-number.directive';

@NgModule({
  declarations: [OnlyNumberDirective, TwoDigitDecimaNumberDirective],
  exports: [OnlyNumberDirective, TwoDigitDecimaNumberDirective]
})
export class NumberAcceptModule { }
